
const FlockLogo = () => {

  return (
    <>
      <div className="pulse1"></div>
      <div className="pulse2"></div>
      <div className="icon"></div>
    </>
  )
}

export default FlockLogo